import { Component, OnInit, ChangeDetectionStrategy, DestroyRef, ChangeDetectorRef } from '@angular/core';
import {
  PlatformassetPipe,
  PlatformInformationService
} from '../../../../../projects/platform-manager/src/public_api';
import { combineLatest, Observable, startWith, switchMap } from 'rxjs';
import { IconComponent, provideIcons, pay } from '../../../shared/icons';
import { PaymentMethodResponseV1Dto, PaymentService } from '@frontend';
import { AsyncPipe, KeyValuePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlpitranslatePipe } from '../../../core/pipes/alpitranslate.pipe';
import { CurrencyService } from '../../../core/services/currency.service';
import { CrowdinTranslationService } from '../../services/crowdin-translation.service';
import { loaderMap } from './translations/loader-map';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlpitranslatePipe, IconComponent, PlatformassetPipe, AsyncPipe, KeyValuePipe],
  providers: [provideIcons({ pay })]
})
export class PaymentMethodsComponent implements OnInit {
  paymentMethods$: Observable<PaymentMethodResponseV1Dto[]>;

  constructor(
    private platformInformationService: PlatformInformationService,
    private paymentService: PaymentService,
    private currencyService: CurrencyService,
    private destroyRef: DestroyRef,
    private crowdinTranslationService: CrowdinTranslationService,
    private crd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.crowdinTranslationService.watchLangChange({
      loaderMap: loaderMap,
      destroyRef: this.destroyRef,
      successCallback: () => this.crd.markForCheck()
    });
    this.paymentMethods$ = combineLatest([
      this.platformInformationService.customerCountryCode$,
      this.currencyService.onCurrencyChange.pipe(startWith(this.currencyService.actualCurrency))
    ]).pipe(
      switchMap(([countryCode, currency]) =>
        this.paymentService.apiPaymentAppModulesPaymentmodulePaymentGetpaymentmethodslistv1actionInvokeV1(
          this.platformInformationService.getCurrentPlatformShortcode().toUpperCase(),
          countryCode,
          currency
        )
      ),
      takeUntilDestroyed(this.destroyRef)
    );
  }
}
